import React from 'react';
import { useTheme } from '@/components/theme-provider';

interface DynamicLogoProps {
  className?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function DynamicLogo({ className = '', alt = 'Kestrel AI', size = 'md' }: DynamicLogoProps) {
  const { theme } = useTheme();
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    if (theme === 'dark') return true;
    if (theme === 'light') return false;
    return document.documentElement.classList.contains('dark');
  });
  
  // Update when theme or system theme changes
  React.useEffect(() => {
    const updateDarkMode = () => {
      if (theme === 'dark') {
        setIsDarkMode(true);
      } else if (theme === 'light') {
        setIsDarkMode(false);
      } else {
        // For 'system' theme, check the actual applied theme
        setIsDarkMode(document.documentElement.classList.contains('dark'));
      }
    };

    updateDarkMode();

    if (theme === 'system') {
      const observer = new MutationObserver(updateDarkMode);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      return () => observer.disconnect();
    }
  }, [theme]);
  
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };
  
  const logoSrc = isDarkMode ? '/Logo_Kestrel AI_dark_mode.svg' : '/Logo_Kestrel AI_light_mode.svg';
  
  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`${sizeClasses[size]} object-contain ${className}`}
    />
  );
}